module.exports = __webpack_public_path__ + "img/666-4bfc04.png";